import { useContext, useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import BootstrapDataContext from '../../context/BootstrapDataContext'
import { LOCATION_SEARCH_TYPE } from '../../types'
import { FLY } from '../Hotels/constants'
import { TRIP_TYPE } from '../Hotels/types'
import useSeti from './useSeti'

const getCityNameBtnTextFromLocation = (
  location: LOCATION_SEARCH_TYPE | null
) =>
  !!location?.cityName && location?.type === 'CITY'
    ? `Find ${location.cityName} Hotels`
    : null

const SUBMIT_BTN_TEXT = 'Find Your Hotel'

export default function useCityNameInBtnTextExperiment(
  tripType: TRIP_TYPE,
  endLocation: LOCATION_SEARCH_TYPE | null
) {
  const { isMobile, prePopData } = useContext(BootstrapDataContext)
  const prePopEndLocation = prePopData?.hotels?.endLocation
  const hasCityInPrePop =
    !!prePopEndLocation?.cityName && prePopEndLocation?.type === 'CITY'
  const { pathname } = useRouter()
  const hotelsPage = pathname === '/hotels'
  const isMobileHotelsLP = hotelsPage && isMobile
  const isCityNameBtnTextTestInVariant =
    useSeti(
      'HOTELS_LP_SEM_CITY_BUTTON',
      isMobileHotelsLP && hasCityInPrePop
    ) === 'VARIANT'
  const allowCityNameBtnText =
    isMobileHotelsLP && hasCityInPrePop && isCityNameBtnTextTestInVariant
  const [searchBtnText, setSearchBtnText] = useState(
    (allowCityNameBtnText && getCityNameBtnTextFromLocation(endLocation)) ||
      SUBMIT_BTN_TEXT
  )
  const hasFlight = tripType.includes(FLY)

  useEffect(() => {
    setSearchBtnText(
      (allowCityNameBtnText &&
        !hasFlight &&
        getCityNameBtnTextFromLocation(endLocation)) ||
        SUBMIT_BTN_TEXT
    )
  }, [endLocation, hasFlight, allowCityNameBtnText])

  return searchBtnText
}
